__webpack_require__.p = "https://widget.spamhaus.com/xbl-widget-demo/";